<template>
  <div class="bg-secondary-3">
    <div class="py-1 px-4 rounded">
      <div class="row mt-4">
        <div class="col-12 d-flex">
          <i class="fas fa-calendar-alt text-orange mr-2 mt-1"></i>
          <p class="font-weight-normal font-18">
            Modificar Fecha de Discusión
          </p>
        </div>
      </div>
      <ValidationObserver ref="academicProgressModifyDiscussionDate">
        <div class="row">
          <div class="col-12">
            <div class="row">
              <div class="col-12 col-md-2">
                <ValidationProvider
                  v-slot="{ errors }"
                  name="date"
                  rules="required"
                >
                  <custom-date-picker
                    v-model="model.dateDiscussion"
                    required
                    label="Fecha de Discusión"
                    placeholder="DD/MM/YYYY"
                    :min-date="minDate"
                    :max-date="new Date()"
                    :error="errors[0]"
                    custom-error-msg="La fecha de discusión es requerida."
                  />
                </ValidationProvider>
              </div>
            </div>
          </div>
          <div class="col-12">
            <div class="main-content mt-2">
              <div class="mb-3">
                <ValidationProvider
                  v-slot="{ errors }"
                  name="reason"
                  rules="required"
                >
                  <custom-text-area
                    v-model="model.comment"
                    required
                    :maxlength="3000"
                    label="Comentario:"
                    :error="errors[0]"
                    :custom-error-msg="'El Comentario es requerido'"
                    show-char-count
                    :count-classes="['d-block', 'small-counter', 'text-right']"
                  />
                </ValidationProvider>
              </div>
              <div class="d-flex justify-content-end align-items-center px-0">
                <action-button
                  type="button"
                  text="Cancelar"
                  i="fa fa-times-circle"
                  variant="outline-danger"
                  class="ml-2 px-4 mb-3 actionButton"
                  @click="close()"
                />

                <action-button
                  type="button"
                  text="Guardar"
                  i="fas fa-save"
                  variant="success"
                  class="ml-2 px-4 mb-3 actionButton"
                  @click="save()"
                />
              </div>
            </div>
          </div>
        </div>
      </ValidationObserver>
    </div>
  </div>
</template>

<script>
import peiService from '@/services/pei/peiAcademicProgressCalendar.js';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import ActionButton from 'ActionButton';
import CustomDatePicker from 'custom-date-picker';
import CustomTextArea from 'CustomTextArea';
import alert from '@/mixin/alert.mixin';
import objectToFormData from 'object-to-formdata';

export default {
  name: 'AcademicProgressModifyDiscussionDate',
  components: {
    ValidationProvider,
    ValidationObserver,
    ActionButton,
    CustomDatePicker,
    CustomTextArea,
  },
  data: () => ({
    model: {
      dateDiscussion: null,
      comment: null,
    },
  }),
  mixins: [alert],
  props: {
    academicProgressId: {
      type: Number,
      default: null,
      require: true,
    },
    minDate: {
      type: Date,
      default: null,
      require: true,
    },
  },
  methods: {
    async save() {
      const isValid = await this.$refs.academicProgressModifyDiscussionDate.validate();

      if (!isValid) {
        this.ShowToast(
          'Error',
          'Favor de completar la información solicitada.',
          'error'
        );
        return;
      }

      const model = {
        academicProgressId: this.academicProgressId,
        dateDiscussion: this.model.dateDiscussion,
        comment: this.model.comment,
      };

      await peiService.modifyDiscussionDate(model).then(
        () => {
          this.ShowToast(
            'Proceso exitoso.',
            'La fecha de discusión se ha modificado correctamente.',
            'success'
          );
          this.model.dateDiscussion = null;
          this.model.comment = null;
          this.$emit('saved');
        },
        (error) => {
          this.ShowToast('Alerta', `${error.response.data.message}.`, 'error');
          return { data: false };
        }
      );
    },
    async close() {
      this.model.dateDiscussion = null;
      this.model.comment = null;
      this.$emit('cancel');
    },
  },
};
</script>

<style lang="scss" scoped></style>
